import styled from '@emotion/styled'
import { Divider as DividerMUI } from '@mui/material'
import { theme } from 'styles/theme/hav-theme'

export const Container = styled.div`
  padding: ${theme.spacing.sm} 8px;
`

export const NameText = styled.span`
  font-size: ${theme.typography.sizes.sm};
  color: ${theme.colors.neutral.high};
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.lg};
`

export const EmailContainer = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 13.5px;
`

export const EmailText = styled.span`
  font-size: ${theme.typography.sizes['2xs']};
  color: ${theme.colors.neutral.high};
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.sm};
`

export const Divider = styled(DividerMUI)`
  margin: ${theme.spacing.xm} -18px;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
